export const LoansLandingPageTexts = {
  OffersTitle: 'Условия от банков',
  OfferSubmitButtonText: 'Продолжить',
};
